import type { Movie } from "@/pages/home/types";

interface MovieCardProps {
  movie: Movie;
  showRank?: boolean;
}

export default function MovieCard({ movie, showRank = false }: MovieCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative h-56 w-full overflow-hidden bg-background-200">
        <img
          src={movie.img}
          alt={`《${movie.title}》风格封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {showRank && movie.rank !== null && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
            {movie.rank}
          </span>
        )}
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-medium text-accent-300">
          <i className="ri-star-fill" />
          {movie.score}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950">{movie.title}</h3>
        <p className="mt-1 text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.duration}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {movie.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600">{movie.summary}</p>
        <p className="mt-3 border-t border-background-200 pt-3 text-xs text-foreground-500">
          导演：{movie.director}
        </p>
      </div>
    </article>
  );
}